import { Button } from 'components/ui/Button/Button'
import { NumberInput } from 'components/ui/NumberInput/NumberInput'
import TitledContainer from 'components/ui/TitledContainer/TitledContainer'
import { ContainerType } from 'services/warehouse-containers/containers'

const MAX_AVAILABLE_CONTAINERS_AT_ONCE = 200

export type Props = {
  containerType: ContainerType
  buttonText?: string
  disabled?: boolean
  value?: number
  maxValue?: number
  onSubmit?: () => void
  onChange?: (value: number) => void
}

export const ContainerTypeOverview = ({
  containerType,
  value,
  disabled,
  buttonText = 'Изменить',
  maxValue = MAX_AVAILABLE_CONTAINERS_AT_ONCE,
  onSubmit,
  onChange,
}: Props) => (
  <TitledContainer title={containerType?.name}>
    <div style={{ textAlign: 'left' }}>
      <div className="divider"></div>
      <div className="divider">
        <span className="hint">Текстовый идентификатор: </span>
        <span>{containerType.slug}</span>
      </div>
      <div className="divider">
        <span className="hint">Описание: </span>
        <span>{containerType.summary}</span>
      </div>
      <div className="divider">
        <span className="hint">Тип: </span>
        <span>{containerType.type === 'delivery' ? 'Для доставки' : 'Для сбора'}</span>
      </div>
      <div className="divider">
        <span className="hint">Всего на складе: </span>
        <span>{containerType.amount.total}</span>
      </div>
      <div className="divider">
        <span className="hint">Используется: </span>
        <span>{containerType.amount.used}</span>
      </div>
    </div>
    <div>
      <div style={{ marginBottom: '0.5rem' }}>
        <NumberInput value={value} onChange={onChange} max={maxValue} />
      </div>
      <Button disabled={disabled} title={buttonText} handleOnSubmit={onSubmit} />
    </div>
  </TitledContainer>
)
